module.exports = __webpack_public_path__ + "static/media/8778.c2732bc1.png";